<template>
  <div v-loading="listContentLoading">
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px;"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <el-button type="primary" size="mini" @click="openDialog()">
          添加</el-button
        >
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
          prop="id"
          label="规格ID"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          label="标题"
          align="center"
          min-width="25%"
          prop="title"
        >
        </el-table-column>

        <el-table-column label="说明" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="openIntro(row.title, row.intro)"
            >
              <div>{{ row.intro }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="price"
          label="价格"
          align="center"
          min-width="10%"
        ></el-table-column>

        <el-table-column
          prop="stock"
          label="库存"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              size="mini"
              @click="deleteItem(id, row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- <el-row>
        <div class="block">
          <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-row> -->

    <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="addEditFormOnClose"
      width="50%"
    >
      <el-form :model="itemInfo" label-width="100px" class="demo-ruleForm">
        <el-form-item label="遇见食宿">
          <el-select
            v-if="lodging_id == 0"
            v-model="itemInfo.lodging_id"
            class="search-el"
            size="mini"
            placeholder="选择遇见食宿"
            filterable
            @change="lodgingChange($event)"
          >
            <el-option
              v-for="item in LodgingList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-input
            v-if="lodging_id > 0"
            v-model="lodging_title"
            :disabled="true"
          ></el-input>
        </el-form-item>

        <el-form-item label="规格">
          <el-checkbox-group v-model="item_ids">
            <el-checkbox
              v-for="item in LodgingItemList"
              :key="item.id"
              :label="item.id"
              :checked="item_ids.indexOf(item.id.toString()) >= 0"
            >{{ item.title }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="primary" @click="submitItemIds">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getLodgingTitle, getLodgingItemTitleList } from "@/api/lodging";
import {
  getActivityLodgingItemList,
  setActivityLodgingItem,
  delActivityLodgingItem,
} from "@/api/activity";

export default {
  data: function () {
    return {
      dialogVisible: false,
      id: this.$route.query.id,
      lodging_id: 0,
      lodging_title: "",
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        title: "",
        id: this.$route.query.id,
      },

      item_ids: [],
      itemInfo: {
        lodging_id: "",
        item_ids: [],
      },

      LodgingList: [],
      LodgingItemList: [],

      listContentLoading: false,

      updateLoading: false,
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    submitItemIds() {
        setActivityLodgingItem({
          id: this.id,
          lodging_id: this.itemInfo.lodging_id,
          item_ids: this.item_ids
        }).then((response) => {
          if (response.status == 2000) {
            this.dialogVisible = false;
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
    },
    lodgingChange(lodging_id) {
      this.itemInfo = {
        lodging_id: lodging_id,
        item_ids: [],
      };
      this.getLodgingItemTitleList(lodging_id);
    },
    openIntro(title, intro) {
      this.$alert(intro, title);
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.dialogVisible = false;
    },
    openDialog() {
      this.dialogVisible = true;
      if (this.lodging_id == 0) {
        getLodgingTitle().then((response) => {
          this.LodgingList = response.data;
        });
      } else {
        this.itemInfo.lodging_id = this.lodging_id;
        this.getLodgingItemTitleList(this.lodging_id);
      }
    },

    getLodgingItemTitleList(lodging_id) {
      getLodgingItemTitleList({ id: lodging_id }).then((response) => {
        this.LodgingItemList = response.data;
      });
    },

    getList() {
      this.loading = true;
      getActivityLodgingItemList(this.query).then((response) => {
        this.list = response.data.list;
        this.lodging_id = response.data.lodging_id;
        this.lodging_title = response.data.lodging_title;
        this.item_ids = response.data.item_ids;

        this.loading = false;
      });
    },

    deleteItem(id, item_id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delActivityLodgingItem({
          id: id,
          item_id: item_id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>
<style>
.el-message-box__title {
  padding-right: 20px;
}
</style>